import { render, staticRenderFns } from "./FileDragAndDrop.vue?vue&type=template&id=3b3df6ac&scoped=true&"
import script from "./FileDragAndDrop.vue?vue&type=script&lang=ts&"
export * from "./FileDragAndDrop.vue?vue&type=script&lang=ts&"
import style0 from "./FileDragAndDrop.vue?vue&type=style&index=0&id=3b3df6ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3df6ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
